import React from 'react';
import PropTypes from 'prop-types';

import {
  SplitBanner,
  SplitBannerContent,
  SplitBannerImage,
} from '@lanl-web/lanl-components';

import { getImageUrl } from '../../utils';

export const FeaturedPost = ({ featuredPost, showMore }) => {
  const featuredContent = {
    image:
      featuredPost?.feature_image?.filename_disk ??
      featuredPost?.card_image?.filename_disk,
    title: featuredPost?.title ?? '',
    btnText: featuredPost?.button_text ?? 'Read Story',
    category: featuredPost?.banner_section_title ?? '',
    subtitle: featuredPost?.description ?? '',
    url: `/posts/${featuredPost?.slug}` ?? '',
    buttonLinkTwo: showMore ? '/posts' : '',
    buttonTextTwo: showMore ? 'More Blog Posts' : '',
  };

  return (
    <SplitBanner>
      <SplitBannerImage imgUrl={getImageUrl(featuredContent.image)} />
      <SplitBannerContent
        title={featuredContent.title}
        description={featuredContent.subtitle}
        buttonLink={featuredContent.url}
        buttonText={featuredContent.btnText}
        buttonLinkTwo={featuredContent.buttonLinkTwo}
        buttonTextTwo={featuredContent.buttonTextTwo}
      />
    </SplitBanner>
  );
};

FeaturedPost.defaultProps = {
  featuredPost: [],
  showMore: false,
};

FeaturedPost.propTypes = {
  featuredPost: PropTypes.array.isRequired,
  showMore: PropTypes.bool,
};

export default FeaturedPost;
